import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { HiOutlineX } from "react-icons/hi";

import Button from "../../components/ui/Button";
import PaymentStatusLayout from "./PaymentStatusLayout";
import PaymentPageLogo, { PaymentEyebrow } from "./PaymentPageBrandHeader";
import { getStoredUser } from "../../utils/authStorage";

function CancelIcon() {
  return (
    <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-bg-light-blue ring-8 ring-bg-light-blue/80">
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white border border-border-grey">
        <HiOutlineX className="h-6 w-6 text-dark-grey" strokeWidth={2.5} aria-hidden="true" />
      </div>
    </div>
  );
}

export default function PaymentCancelledPage() {
  const navigate = useNavigate();
  const isAuthenticated = Boolean(getStoredUser()?.userId);

  return (
    <PaymentStatusLayout>
      <PaymentPageLogo />

      <div className="mt-10">
        <CancelIcon />
        <div className="mt-8">
          <PaymentEyebrow tone="muted">Checkout canceled</PaymentEyebrow>
        </div>
        <h1 className="mt-3 text-[1.75rem] font-semibold leading-snug text-dark-black">
          No payment was made
        </h1>
        <p className="mt-4 text-sm leading-6 text-dark-grey">
          You can return to billing anytime to choose a plan when you&apos;re ready.
        </p>
      </div>

      <div className="mt-10 flex flex-col gap-3.5">
        {isAuthenticated ? (
          <>
            <Button
              variant="primary"
              fullWidth
              size="sm"
              onClick={() => navigate("/settings/billing", { replace: true })}
            >
              Back to billing
            </Button>
            <Button variant="outline" fullWidth size="sm" onClick={() => navigate("/", { replace: true })}>
              Go to dashboard
            </Button>
          </>
        ) : (
          <>
            <Button variant="primary" fullWidth size="sm" onClick={() => navigate("/login", { replace: true })}>
              Sign in
            </Button>
            <Button
              variant="outline"
              fullWidth
              size="sm"
              onClick={() => navigate("/register", { replace: true })}
            >
              Create account
            </Button>
          </>
        )}
      </div>

      {!isAuthenticated ? (
        <p className="mt-6 text-sm leading-6 text-dark-grey">
          Already have an account?{" "}
          <Link to="/login" className="font-medium text-brand-blue underline underline-offset-2">
            Sign in
          </Link>
        </p>
      ) : null}
    </PaymentStatusLayout>
  );
}
